﻿/**
 * AUXITO PDP Carousel (JS only)
 * - 你只需要在富文本轮播最外层加一个类名：`.js-auxito-carousel`
 * - 兼容你现有的结构（auxito-carousel-3 / carousel-*-3）
 * - 不依赖 jQuery
 * - 仅在产品页运行（JS guard；且脚本也只在产品页引入）
 */
(function () {
  function isProductPage() {
    var body = document.body;
    if (!body) return false;
    // Theme adds classes like: "template-product" and/or "product"
    return body.classList.contains('product') || /\btemplate-product\b/.test(body.className);
  }
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }
  function findSuffixByPrefixClass(root, prefix) {
    // 在 root 子树里找第一个 class 形如 `${prefix}${suffix}` 的元素，并返回 suffix（如 "1"/"3"）
    var els = root.querySelectorAll('[class]');
    for (var i = 0; i < els.length; i++) {
      var cl = els[i].classList;
      if (!cl) continue;
      for (var j = 0; j < cl.length; j++) {
        var c = cl[j];
        if (c && c.indexOf(prefix) === 0) {
          return c.slice(prefix.length);
        }
      }
    }
    return null;
  }
  function initCarousel(root) {
    if (root.__auxitoPdpCarouselInited) return;
    root.__auxitoPdpCarouselInited = true;
    // 兼容富文本里的结构（后缀数字可变：1/2/3/...）
    var suffix = findSuffixByPrefixClass(root, 'carousel-slides-');
    var track = suffix ? root.querySelector('.carousel-slides-' + suffix) : null;
    if (!track) track = root.querySelector('.auxito-pdp-carousel__track'); // 兼容新结构（如果未来用）
    if (!track) return;
    var slides = [];
    if (suffix) slides = Array.prototype.slice.call(track.querySelectorAll('.carousel-slide-' + suffix));
    if (!slides.length) slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var prevBtn = suffix ? root.querySelector('.carousel-prev-' + suffix) : null;
    if (!prevBtn) prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = suffix ? root.querySelector('.carousel-next-' + suffix) : null;
    if (!nextBtn) nextBtn = root.querySelector('[data-carousel-next]');
    var dotsWrap = suffix ? root.querySelector('.carousel-pagination-' + suffix) : null;
    if (!dotsWrap) dotsWrap = root.querySelector('[data-carousel-dots]');
    var oldDots = [];
    if (dotsWrap && suffix) oldDots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.carousel-dot-' + suffix));
    // 如果富文本里已经有 dots（carousel-dot-3），就直接复用；否则如果是新结构再建 dots
    var dots = oldDots;
    if (!dots.length && dotsWrap && dotsWrap.hasAttribute('data-carousel-dots')) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'auxito-pdp-carousel__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.setAttribute('data-carousel-dot', String(i));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }
    var index = 0;
    function render() {
      index = clamp(index, 0, slides.length - 1);
      // 旧富文本 CSS 通常是：
      //   .carousel-slides-3 { display:flex; }
      //   .carousel-slide-3 { min-width:100%; display:none; }
      //   .carousel-slide-3.active { display:block; }
      //
      // 如果继续让非 active slide = display:none，同时又用 translateX 滑动，
      // track 的宽度会塌缩，滑到第二屏会出现“空白”。
      // 因此：JS 接管后统一把所有 slide 设为 display:block，再用 translateX 实现切换。
      if (track && track.style) track.style.display = 'flex';
      for (var i = 0; i < slides.length; i++) {
        if (!slides[i]) continue;
        // 内联覆盖 display:none，确保 track 宽度稳定
        slides[i].style.display = 'block';
        if (slides[i].classList) slides[i].classList.toggle('active', i === index);
      }
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
      for (var j = 0; j < dots.length; j++) {
        if (!dots[j]) continue;
        // 新结构用 aria-current；旧结构用 class active + data-slide
        if (suffix && dots[j].classList && dots[j].classList.contains('carousel-dot-' + suffix)) {
          dots[j].classList.toggle('active', j === index);
        } else {
          dots[j].setAttribute('aria-current', j === index ? 'true' : 'false');
        }
      }
    }
    function goTo(i) {
      index = i;
      render();
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !(t instanceof Element)) return;
        // 旧结构：data-slide
        var vOld = t.getAttribute('data-slide');
        if (vOld != null) {
          var nOld = parseInt(vOld, 10);
          if (isFinite(nOld)) return goTo(nOld);
        }
        // 新结构：data-carousel-dot
        var v = t.getAttribute('data-carousel-dot');
        if (v == null) return;
        var n = parseInt(v, 10);
        if (!isFinite(n)) return;
        goTo(n);
      });
    }
    // Keyboard support when focused inside carousel
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        goTo(index - 1);
      } else if (e.key === 'ArrowRight') {
        goTo(index + 1);
      }
    });
    render();
  }
  function initTechViewMore() {
    // 仅产品详情：技术参数“View all / View less”展开收起
    var btn = document.querySelector('.tech-view-more-btn');
    var extraSpecs = document.querySelector('.tech-extra-specs');
    var btnText = document.querySelector('.tech-btn-text');
    var arrowIcon = document.querySelector('.tech-arrow-icon');
    if (!btn || !extraSpecs || !btnText || !arrowIcon) return;
    if (btn.__auxitoTechToggleBound) return;
    btn.__auxitoTechToggleBound = true;
    btn.addEventListener('click', function () {
      var isHidden = extraSpecs.style.display === 'none' || !extraSpecs.style.display;
      if (isHidden) {
        extraSpecs.style.display = 'block';
        btnText.textContent = 'View less';
        arrowIcon.classList.add('rotated');
      } else {
        extraSpecs.style.display = 'none';
        btnText.textContent = 'View all';
        arrowIcon.classList.remove('rotated');
      }
    });
  }
  function initAll() {
    if (!isProductPage()) return;
    // 只在“产品详情富文本区域”内初始化（主题里该区域容器带 `.product-description.rte`）
    // 你只需要在轮播最外层加：`js-auxito-rich-carousel`
    var roots = document.querySelectorAll('.product-description.rte .js-auxito-rich-carousel');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
    initTechViewMore();
  }
  // 暴露全局 reinit 方法
  window.auxitoPdpCarousel={
    reinit: function () {
      initAll();
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
